import React from "react";
import PropTypes from "prop-types";
import checkIcon from "../../assets/icons/check.svg";
import useFunction from "../../hooks/useFunction";
import Button from "../Button/Button";
// import "./Checkboxes-style.scss";

const SettingCheckboxes = (props) => {

  const {objIsEmpty} = useFunction()


  const {
    label = '',
    text = '',
    className = '',
    hasError = false,
    error = '',
    afterLabel,
    data,
    formData,
    save,
    setting,
  } = props

  /**
   *
   * @param index
   */
  const onChange = (index) => {
    const name = data[index].name;
    let current = formData.model.settings_all[setting];
    const isUnique = data[index].unique_value === true;
    const exists = current.includes(name);

    if (isUnique) {
      if (exists) {
        formData.model.settings_all[setting] = [];
        save();
      } else {
        // Zet alleen de unieke waarde
        formData.model.settings_all[setting] = [name];
        save();
      }
      return;
    }

    // Normale waarde: eerst unieke eruit filteren
    current = current.filter(item => {
      const d = data.find(d => d.name === item);
      return !(d && d.unique_value === true);
    });

    const updated = exists
      ? current.filter(item => item !== name)
      : [...current, name];

    formData.model.settings_all[setting] = updated;
    save();
  };


  const isChecked = (index) => {

    if (objIsEmpty(formData.model)){
      return false
    }

    const name = data[index].name;
    const current = formData.model.settings_all[setting];
    return current.includes(name);
  }


  return (
    <div className={className + 'checkboxes '}>
      <h3>{label}</h3>
      {text && text !== '' &&
        <p className="text-small">{text}</p>
      }
      {hasError && <span className="error"> - {error}</span>}
      <div className="form-row items">

        {data && data.map((item, index) => (
          <div
            className={"item " + (isChecked(index) ? 'checked' : '')}
            onClick={()=> onChange(index)}
            key={index}
          >
            <div className="box">
              {isChecked(index) &&
                <img src={checkIcon} alt="checked"/>
              }
            </div>

            {item.label &&
              <h3>{item.label}</h3>
            }
            {item.icon &&
              <img width={70} src={item.icon} alt="check box"/>
            }
            <div className="center">
              <Button
                label={item.button.label}
                color={item.button.color ? item.button.color : "green"}
                onClick={e => e.preventDefault()}
                data-testid={`setting-btn-${item.name}`}
              />
            </div>

            {item.text &&
              <>
                <br/>
                <ul className="color-grey">
                  <div>
                    {item.text[0].split('\n').map((line, index) => (
                      <div key={index}>{line}</div>
                    ))}
                  </div>
                </ul>
              </>
            }

          </div>
        ))}
      </div>

      {/*<label>*/}
      {/*  <div className="form-row">*/}
      {/*    <input*/}
      {/*      disabled={isLoading}*/}
      {/*      name={name}*/}
      {/*      checked={getValue(value)}*/}
      {/*      onChange={onChange}*/}
      {/*      type='checkbox'*/}
      {/*    />*/}

      {/*  </div>*/}
      {/*</label>*/}
      {afterLabel &&
        <span className="after-label">{afterLabel}</span>
      }

    </div>
  )
}

SettingCheckboxes.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  data: PropTypes.array,
  setting: PropTypes.string,
}

export default SettingCheckboxes
